var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "companies-section" },
    [
      _c("el-card", [
        _c("h3", [_vm._v("DISTRIBUIDORA")]),
        _vm._v(
          " " +
            _vm._s(_vm.distributorCode) +
            " - " +
            _vm._s(_vm.distributorName) +
            " "
        ),
      ]),
      _c("el-card", [
        _c("h3", [_vm._v("COMERCIALIZADORA")]),
        _vm._v(
          " " +
            _vm._s(_vm.marketerCode) +
            " - " +
            _vm._s(_vm.marketerName) +
            " "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }